// extracted by mini-css-extract-plugin
export default {"main-block":"NAOydw","item":"hze48y"};